import React from 'react';
import AuthForm from './auth-form.jsx';
import AuthShell from './auth-shell.jsx';

function AuthFullScreenSignUp() {
	return <AuthShell variant="full-screen"><AuthForm variant="full-screen" mode="sign-up" /></AuthShell>;
}

export default AuthFullScreenSignUp;
